var api = require("!../../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../css-loader/dist/cjs.js!../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?{\"source\":\"Ll8xM2pvMzNtMCB7CiAgZGlzcGxheTogZ3JpZDsKICBhbGlnbi1pdGVtczogY2VudGVyOwogIGp1c3RpZnktY29udGVudDogY2VudGVyOwogIGNvbHVtbi1nYXA6IDEwcHg7Cn0KLl8xM2pvMzNtMSB7CiAgZ3JpZC10ZW1wbGF0ZS1jb2x1bW5zOiAzMHB4IDEzNjNweCAzMHB4Owp9Ci5fMTNqbzMzbTIgewogIGdyaWQtdGVtcGxhdGUtY29sdW1uczogMTM2M3B4Owp9Ci5fMTNqbzMzbTMgewogIGdyaWQtdGVtcGxhdGUtY29sdW1uczogMzBweCAxMDE3cHggMzBweDsKfQouXzEzam8zM200IHsKICBncmlkLXRlbXBsYXRlLWNvbHVtbnM6IDEwMTdweDsKfQouXzEzam8zM201IHsKICBncmlkLXRlbXBsYXRlLWNvbHVtbnM6IDMwcHggNjcxcHggMzBweDsKfQouXzEzam8zM202IHsKICBncmlkLXRlbXBsYXRlLWNvbHVtbnM6IDY3MXB4Owp9Ci5fMTNqbzMzbTcgewogIGdyaWQtdGVtcGxhdGUtY29sdW1uczogMzBweCAzNDBweCAzMHB4Owp9Ci5fMTNqbzMzbTggewogIGdyaWQtdGVtcGxhdGUtY29sdW1uczogMzQwcHg7Cn0KLl8xM2pvMzNtOSB7CiAgd2lkdGg6IGZpdC1jb250ZW50OwogIG1hcmdpbjogN3B4OwogIHBvc2l0aW9uOiByZWxhdGl2ZTsKfQouXzEzam8zM21hIHsKICBqdXN0aWZ5LXNlbGY6IHN0YXJ0Owp9\"}!./vanilla-extract-webpack-plugin-extracted.cjs.js");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};